import { useCallback } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useTranslation as useTranslationOrig } from "react-i18next";

// i18n safe (évite TS2589)
type RawT = (key: string, options?: Record<string, unknown>) => any;
const useTranslationSafe = (ns?: string) =>
  (useTranslationOrig as unknown as (ns?: any) => { t: RawT })(ns);

const Cancel = () => {
  const { t: tRaw } = useTranslationSafe("cancel");
  const tr = useCallback(
    (key: string, options?: Record<string, unknown>) => {
      const out = tRaw(key, options);
      if (typeof out === "string") return out;
      if (Array.isArray(out)) return out.join("");
      return String(out ?? "");
    },
    [tRaw]
  );

  return (
    <section className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
      <div className="mx-auto w-full max-w-md rounded-2xl border border-gray-200 bg-white/80 p-8 shadow-sm dark:border-white/10 dark:bg-white/5">
        <div className="flex items-center justify-center gap-2">
          <XCircle className="h-6 w-6 text-red-600" />
          <h1 className="text-xl font-semibold">
            {tr("title", { defaultValue: "Paiement annulé" })}
          </h1>
        </div>

        <p className="mt-3 text-sm text-gray-600 dark:text-gray-300">
          {tr("description", {
            defaultValue: "Le paiement a été interrompu. Tu peux retenter quand tu veux.",
          })}
        </p>

        <div className="mt-6 flex gap-2">
          <Link
            to="/upgrade"
            className="inline-flex items-center justify-center rounded-lg bg-orange-600 px-4 py-2.5 font-semibold text-white hover:bg-orange-700"
          >
            {tr("buttons.retryUpgrade", { defaultValue: "Revenir à l’upgrade" })}
          </Link>
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white/70 px-4 py-2.5 font-semibold text-gray-900 hover:bg-white dark:border-white/10 dark:bg:white/5 dark:text-gray-100"
          >
            {tr("buttons.home", { defaultValue: "Accueil" })}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Cancel;
export {};
